import React, { Component } from 'react';
import { BrowserRouter, Switch, Route } from 'react-router-dom';
import { Form, Make, Admin, SelectStyle, Complete } from './components';
import './App.css';

class App extends Component {
  handleClick = () => {  
    console.log(1);
  }
  render() {
    
    return (
      <BrowserRouter>
        <Switch>
          <Route exact path="/" component={SelectStyle}></Route>
          <Route exact path="/make" component={Make}></Route>
          <Route exact path="/complete" component={Complete}></Route>
          <Route exact path="/admin" component={Admin}></Route>
          <Route exact path="/:styleId" component={Form}></Route>
        </Switch>
      </BrowserRouter>
    );
  }
}

export default App;
